/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import Header from './Header';
import SwiperContainer from './SwiperContainer';
import { DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_INDEX } from './__tests__/constant';
import { Wrapper } from './styled';
import useSuggestedPeopleWidget from './Hooks/useSuggestedPeopleWidget';

function SuggestedPeopleWidget() {
  const { data } = useSuggestedPeopleWidget();

  if (data?.length === 0) return null;

  return (
    <Wrapper data-cy={DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_INDEX}>
      <Header />
      <SwiperContainer />
    </Wrapper>
  );
}

export default SuggestedPeopleWidget;
